module.exports = __webpack_public_path__ + "img/group26998.4bba133d.svg";